<div class="card-title" [ngClass]="{'card-title-valid' : valid}">
  <div class="status-block"></div>
  <div class="title">
    {{ title | translate }}
  </div>
  <div class="status-icon ms-auto">
    <img *ngIf="valid" src="assets/icons/Success.svg">
  </div>
</div>
